import { create } from "zustand";

type SamEntityState = {
  uei: string;
  setUei: (uei: string) => void;
};

export const useSamEntityStore = create<SamEntityState>((set) => ({
  uei: "",
  setUei: (uei) => set({ uei }),
}));